import {
  Button,
  Col,
  Container,
  Form,
  Image,
  Card,
  Row,
} from "react-bootstrap";

import { Link } from "react-router-dom";
import SignUp from "../../sign up/signUp";
import swal from "sweetalert";

import img1 from "./../../../assets/img/girl-thumb.svg";
import loop from "./../../../assets/img/placeholder.svg";
import img3 from "./../../../assets/img/laptop.svg";
import img4 from "./../../../assets/img/Progress circle.svg";
import img5 from "./../../../assets/img/Board.svg";
import ellipse1 from "./../../../assets/img/Ellipse1.svg";
import ellipse2 from "./../../../assets/img/Ellipse2.svg";
import spiral1 from "./../../../assets/img/spiral2.svg";
import spiral2 from "./../../../assets/img/spiral2.svg";

import icon1 from "./../../../assets/img/vector1.svg";

import icon2 from "./../../../assets/img/Vector2.svg";

import icon3 from "./../../../assets/img/vector3.svg";

import "./body.css";
const BodySection = () => {
  const isLoggedIn = localStorage.getItem("signUp");

  const logout = () => {
    localStorage.removeItem("signUp");
    swal("Logged out");
    window.location.reload();
  };

  return (
    <>
     <Container className="py-5">
      <Row className="align-items-center body-hero justify-content-center text-center">
        <Col lg={6} className="mb-5">
          <div className="d-flex flex-column align-items-center gap-4">
            <h1 className="fw-bold text-gray-800">
              Up Your <span className="text-primary">Skills</span> To{" "}
              <span className="text-primary">Advance</span> Your
              <span className="text-primary"> Education</span>
            </h1>

            <p className="text-muted">
              Practice Past questions with PastQuest. The latest online
              learning system and material that help your knowledge growing.
            </p>

            <div className="d-flex gap-3">
              <Button variant="primary" className="px-4 py-2">
                Get Started
              </Button>
              <Button variant="outline-primary" className="px-4 py-2">
                Get Free Trial
              </Button>
            </div>

            <Row className="g-3 justify-content-center">
              <Col xs={12} md={4} className="d-flex align-items-center justify-content-center gap-2">
                <img
                  src={icon1}
                  alt="English Speaking"
                  className="w-8 h-8"
                />
                <span>English Speaking</span>
              </Col>
              <Col xs={12} md={4} className="d-flex align-items-center justify-content-center gap-2">
                <img
                  src={icon2}
                  alt="Career Oriented"
                  className="w-8 h-8"
                />
                <span>Career Oriented</span>
              </Col>
              <Col xs={12} md={4} className="d-flex align-items-center justify-content-center gap-2">
                <img
                  src={icon3}
                  alt="Creative Thinking"
                  className="w-8 h-8"
                />
                <span>Creative Thinking</span>
              </Col>
            </Row>
          </div>
        </Col>

        <Col lg={6} className="position-relative">
          <div className="text-center">
            <img src={img1} alt="Hero" className="img-fluid mx-auto girl-thumb" />
           
          </div>

          <Row className="g-4 mt-4 justify-content-center">
            <Col md={4} className="mb-4 hero-card hero-card-1">
              <Card className="text-center shadow-sm p-3">
                <div className="d-flex align-items-center justify-content-center gap-3">
                  <img
                    src={img3}
                    alt="Online Tests"
                    className="img-fluid bg-primary p-2 test-icon"
                  />
                  <div>
                    <h4 className="mb-1">2k+</h4>
                    <p className="text-muted mb-0">Online Tests</p>
                  </div>
                </div>
              </Card>
            </Col>

           

         
          </Row>
        </Col>
      </Row>
    </Container>
    </>
  );
};

export default BodySection;
